module.exports = __webpack_public_path__ + "static/media/consensys-2.17815aff.jpg";